export const formatNumber = (value: number) => {
  if (value >= 1000000000) {
    return `${(value / 1000000000).toFixed(1)}B`;
  }
  return `${(value / 1000000).toFixed(1)}M`;
};

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatNumberWithCommas = (value: number) => {
  return new Intl.NumberFormat('vi-VN', {
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatTime = (seconds: number) => {
  if (seconds < 60) {
    return `${formatNumberWithCommas(seconds)}s`;
  }
  const minutes = Math.floor(seconds / 60);
  return `${formatNumberWithCommas(minutes)} phút`;
};
